import axios from 'axios';

export default {
  index: (params = {}, config = {}) => axios.get('services', { params, ...config }),
};
